import { render } from "./PageLayouts.vue?vue&type=template&id=51e94f88"
import script from "./PageLayouts.vue?vue&type=script&lang=js"
export * from "./PageLayouts.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__